// Design tokens para consistencia visual y fácil mantenimiento

export const colors = {
  // Colores primarios
  primary: '#646cff',
  primaryHover: '#5a5fcf',
  
  // Backgrounds
  background: {
    main: '#111',
    page: '#111',
    card: '#1a1a1a',
    sidebar: '#0a0a0a',
    header: '#0f0f0f',
    input: '#222',
    button: '#333',
    buttonHover: '#444',
    overlay: '#0f0f0f'
  },
  
  // Borders
  border: {
    main: '#333',
    subtle: '#444',
    focus: '#646cff',
    input: '#444'
  },
  
  // Text colors
  text: {
    primary: '#fff',
    secondary: '#ccc',
    tertiary: '#bbb',
    muted: '#888',
    disabled: '#666',
    accent: '#a78bfa'
  },
  
  // Status colors
  status: {
    connected: '#22c55e',
    disconnected: '#ef4444',
    warning: '#fbbf24',
    info: '#60a5fa',
    webhook: '#10b981'
  },
  
  // Error states
  error: {
    text: '#ff6b6b',
    background: 'rgba(255, 107, 107, 0.1)',
    border: 'rgba(255, 107, 107, 0.3)'
  }
}

export const spacing = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '0.75rem',
  lg: '1rem',
  xl: '1.5rem',
  '2xl': '2rem',
  '3xl': '3rem',
  '4xl': '4rem'
}

export const borderRadius = {
  sm: '4px',
  md: '6px',
  lg: '8px',
  xl: '12px',
  full: '50%',
  pill: '20px'
}

export const shadows = {
  sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
  md: '0 2px 8px rgba(0, 0, 0, 0.3)',
  lg: '0 8px 32px rgba(0, 0, 0, 0.5)'
}

export const typography = {
  fontSize: {
    xs: '0.75em',
    sm: '0.85em',
    md: '1em',
    lg: '1.1em',
    xl: '1.2em',
    '2xl': '1.4em',
    '3xl': '1.8em',
    '4xl': '2.5em'
  },
  fontWeight: {
    normal: 'normal',
    medium: '500',
    bold: 'bold'
  },
  letterSpacing: {
    tight: '0.5px',
    normal: '1px',
    wide: '2px'
  }
}

export const transitions = {
  fast: 'all 0.2s ease',
  medium: 'all 0.3s ease',
  slow: 'all 0.5s ease'
}
